import React, { useEffect, useState } from 'react';
import LogInForm from './LoginForm';
import logo from '../../../assets/logo/LOGO_CAPBAY_VERTICAL_CROPPED.png';
import Maintenance from '../../../components/Maintenance';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { useDict, useLanguageUpdate } from '../../../contexts/LanguageContext';
import CustomSwitch from '../../../components/CustomSwitch';

const Login = () => {
    const dict = useDict();
    const toggleLanguage = useLanguageUpdate();

    const [language, setLanguage] = useState(localStorage.getItem('language') === 'th');

    const handleChange = (checked) => {
        setLanguage(checked);
        toggleLanguage(checked ? 'th' : 'en');
    };

    const { isUnderMaintenance } = false;


    useEffect(() => {
        sessionStorage.removeItem('resendCount');
    }, []);

    return (
        <>
            <div className="account account--photo">
                <div className="account__wrapper">
                    <div className="account__card login__card">
                        <div>
                            <div className="text-right">
                                <CustomSwitch
                                    checked={language}
                                    onChange={handleChange}
                                    width={65}
                                    height={35}
                                    className="language-switch"
                                    leftText="EN"
                                    rightText="TH"
                                    switchOffClassName="switch-off"
                                    switchOnClassName="switch-on"
                                />
                            </div>
                            <h3 className="account__title">
                                <span
                                    className="account__logo account__logo-style"
                                >
                                    <img
                                        src={logo}
                                        alt="logo"
                                        className="auth-logo"
                                    />
                                </span>
                            </h3>
                        </div>
                        {
                            isUnderMaintenance ?
                                <Maintenance />
                                :
                                <LogInForm />
                        }

                        <div className="account__or_divide">
                            <div className="regulated-by-text">
                                {dict.regulatedByText}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;
